import React from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { Button } from "../ui/button";
import { Label } from "../ui/label";
import { Input } from "../ui/input";
import { AlertOctagon } from "lucide-react";

/**
 * Dialog modal pentru casarea unui PSA. Presentational — primește totul prin props.
 */
export default function PSAScrapDialog({
  target,
  busy,
  reason,
  date,
  note,
  scrapReasons,
  psaLabels,
  canScrapAny,
  onClose,
  onSetReason,
  onSetDate,
  onSetNote,
  onConfirm,
}) {
  const isCizme = target?.psa_category === "cizme";
  return (
    <Dialog open={!!target} onOpenChange={(v) => { if (!v && !busy) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="psa-scrap-dialog">
        <DialogHeader>
          <DialogTitle className="text-red-700 flex items-center gap-2">
            <AlertOctagon size={18}/> Casare echipament PSA
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 text-sm">
          <div className="rounded bg-red-50 border border-red-200 p-2.5">
            <div className="font-semibold text-red-900">{target?.name}</div>
            <div className="text-[11px] text-red-700 mt-0.5">
              {psaLabels[target?.psa_category] || target?.psa_category}
              {target?.psa_size ? ` · mărime ${target.psa_size}` : ""}
              {target?.serial ? ` · SN ${target.serial}` : ""}
            </div>
            <div className="text-[11px] text-red-800 mt-1.5 font-semibold">
              ⚠ Echipamentul va fi scos definitiv din inventar și înregistrat în istoric ca „casat".
            </div>
          </div>
          <div>
            <Label className="small-label">Motivul casării *</Label>
            <Select value={reason} onValueChange={onSetReason}>
              <SelectTrigger className="mt-1" data-testid="psa-scrap-reason"><SelectValue/></SelectTrigger>
              <SelectContent>
                {scrapReasons.map((r) => (
                  <SelectItem key={r.code} value={r.code}>{r.label}</SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>
          <div>
            <Label className="small-label flex items-center gap-1">📅 Data casării <span className="text-red-600">*</span></Label>
            <Input
              type="date"
              value={date}
              onChange={(e) => onSetDate(e.target.value)}
              max={new Date().toISOString().slice(0, 10)}
              required
              className="mt-1"
              data-testid="psa-scrap-date"
            />
          </div>
          <div>
            <Label className="small-label">Notă (opțional)</Label>
            <Input
              value={note}
              onChange={(e) => onSetNote(e.target.value)}
              placeholder="ex: rupt în 2 după 18 luni de uz"
              className="mt-1"
              data-testid="psa-scrap-note"
            />
          </div>
          {!canScrapAny && !isCizme && (
            <div className="text-[11px] text-red-700 bg-red-100 border border-red-300 rounded p-2">
              ⛔ Nu ai voie să casezi acest echipament — doar adminul poate.
            </div>
          )}
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} disabled={busy}>Anulează</Button>
          <Button
            onClick={onConfirm}
            disabled={busy || !date || (!canScrapAny && !isCizme)}
            className="bg-red-600 hover:bg-red-700 text-white"
            data-testid="psa-scrap-confirm"
          >
            {busy ? "Se casează..." : "🗑 Casează definitiv"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
